<template>
    <b-form @submit="onSubmit" autocomplete="off">
        <!-- Page title -->
        <b-row>
            <b-col md="12">
                <h3 class="text-themecolor">{{$t('management.bedrijf')}} <span v-if="command.id">{{$t('klantrelaties.bewerker')}}</span><span v-else>{{$t('klantrelaties.aanmaker')}}</span></h3>
            </b-col>
        </b-row>
        <!-- Page title -->

        <!-- Form content -->
        <b-row>
            <b-col md="12">
                <div class="card">
                    <div class="card-body">
                        <b-form-group label-cols :label="$t('management.bedrijfsnaam')" label-for="name">
                            <b-form-input id="name" v-model="command.name" type="text" :placeholder="$t('management.bedrijfsnaam')" />
                            <validation element="name" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('datatables.domeinnaam')" label-for="domain_name">
                            <b-form-input id="domain_name" v-model="command.domainName" type="text" :placeholder="$t('datatables.domeinnaam')" />
                            <validation element="domain_name" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('management.logo')" label-for="logo">
                            <b-form-input id="logo" v-model="command.logo" type="text" :placeholder="$t('management.logo')" />
                            <validation element="logo" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('management.primarelatienummer')" label-for="prima_relatienummer">
                            <b-form-input id="prima_relatienummer" v-model="command.primaRelatienummer" type="text" :placeholder="$t('management.primarelatienummer')" />
                            <validation element="prima_relatienummer" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('datatables.actief')" label-for="is_active">
                            <b-form-select id="active" v-model="command.active" :options="activeOptions" />
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <!-- Form content -->

        <!-- Submit controls -->
        <b-row>
            <b-col md="12">
                <b-button @click="goTo('index')" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
            </b-col>
        </b-row>
        <!-- Submit controls -->
    </b-form>
</template>
<script>
//Import store
import { mapActions, mapGetters } from 'vuex'

//Import command
import Command from './command'

export default {
    name: 'companies-form',
    data() {
        return {
            command: new Command(),
        }
    },
    computed: {
        activeOptions() {
            return [
                { value: 'true', text: this.$i18n.t('releases.ja') },
                { value: 'false', text: this.$i18n.t('releases.nee') },
            ]
        },
        ...mapGetters('management',['company']),
    },
    methods: {
        ...mapActions('management',['create','update']),
        onSubmit(event) {
            event.preventDefault();
            var vm = this;
            var payload = {
                resource: 'companies',
                params: vm.command
            };
            if(vm.command.id) {
                vm.update(payload)
                .then(()=> {
                    vm.goTo('detail');
                });
            }
            else {
                vm.create(payload)
                .then(() => {
                    vm.goTo('index');
                });
            }
        },
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `companies:${name}` });
        }
    },
    created() {
        var vm = this;
        
        if(vm.$route.name.split(':')[1] == 'update') {
            const item = vm.company;

            if(!item.id) {
                vm.goTo('detail');
            }
            else {
                vm.command = new Command(item);
            }
        }
    }
}
</script>